// NPM
import React, { useState, useEffect } from 'react';
import _ from 'lodash';

// State
import { useSelector } from 'react-redux';

// api
import api from './api';

// Services
import renderService from 'services/renderService';
import scrollService from 'services/scrollService';

function LastUpdated() {
  // State
  const [changelogData, setChangelogData] = useState([]);
  const campaignConfig = useSelector(state => state.campaignConfig.value);
  
  const loadData = async () => {
    const changelogData = await api.loadChangelog();
    setChangelogData(changelogData);
  }

  // Hooks
  useEffect(() => loadData(), []);

  if(!renderService.canRender([campaignConfig, changelogData])) {
    return null;
  }

  const titlePart = _.get(campaignConfig, "sections.LastUpdated.title");
  const latestEntry = changelogData[1];
  const title = `${ titlePart } ${ latestEntry[0] }`;
  const linkText = _.get(campaignConfig, "sections.LastUpdated.linkText");
  
  return (
    <div className="LastUpdated">
      <p>{ title }</p>
      <a onClick={ () => scrollService.scrollToId("Changelog") }>
        { linkText }
      </a>
    </div>
  )

}

export default LastUpdated;
